import { IApiPermissionAction } from './../../types/types';
import { PermissionActionsQuery } from './permissions.operations';

import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { safeResolve } from "../../rxjs";

@Injectable()
export class GqlPermissionActionService {
  public constructor(
    private apollo: Apollo
  ) { }

  public getPermissionActions(): Observable<IApiPermissionAction[]> 
  {
    return this.apollo.query({
      query: PermissionActionsQuery,
    }).pipe(
      safeResolve(true),
      map(records => records.sort((a, b) => a.name < b.name ? -1 : 1))
    );
  }
}